import React from 'react';
import { useSelector } from 'react-redux';

function TableContent({ headers }) {
  const { vehicleTrackingChangeLogData } = useSelector(
    (state) => state.VehicleTrackingReducer,
  );

  const stationActivityLogData =
    vehicleTrackingChangeLogData?.vehicleTrackingChangeLogs || [];

  const renderCell = (headerKey, item) => {
    switch (headerKey) {
      case 'workflow_stage':
        return item.workflow_stage?.name || '';

      case 'action_type':
        return item.action_type?.name || '';

      default:
        return item[headerKey] ?? '';
    }
  };

  return (
    <tbody>
      {stationActivityLogData.length > 0 ? (
        stationActivityLogData.map((item) => (
          <tr key={item.id}>
            {headers.map((header) => (
              <td key={header.value} className="table-data">
                <div className="div-flex-row cg-5 div-align-center">
                  {header.value === 'created' ? (
                    <>
                      <input type="checkbox" className="checkbox-grey" />
                      <span className="text-ellipsis">
                        {renderCell(header.value, item)}
                      </span>
                    </>
                  ) : (
                    <span className="text-ellipsis">
                      {renderCell(header.value, item)}
                    </span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <div className="no-data-found border-bottom">
          <span className="text-sm">No Activity Found</span>
        </div>
      )}
    </tbody>
  );
}

export default TableContent;
